import { PasswordRule, StrengthConfig } from "./types";

const mergeRules = (
    defaultRules: PasswordRule[],
    customRules: PasswordRule[]
): PasswordRule[] => {
    const customRuleIds = customRules.map((rule) => rule.id);
    const filteredDefaults = defaultRules.filter(
        (rule) => !customRuleIds.includes(rule.id)
    );
    return [...filteredDefaults, ...customRules];
};

const evaluatePasswordRules = (password: string, rules: PasswordRule[]) => {
    return rules.map((rule) => ({
        ...rule,
        passed: rule.test(password),
    }));
};

const calculateStrengthLevel = (
    password: string,
    ruleResults: Array<PasswordRule & { passed: boolean }>
): number => {
    if (password.length === 0) return 0;

    let score = 1;

    ruleResults.forEach((rule) => {
        if (rule.passed) {
            score += rule.score;
        }
    });

    if (password.length < 8) {
        score = score - 1;
    }

    const maxPossibleScore =
        1 + ruleResults.reduce((sum, rule) => sum + rule.score, 0);
    const normalizedScore = score / maxPossibleScore;

    if (normalizedScore <= 0.3) return 1;
    if (normalizedScore <= 0.5) return 2;
    if (normalizedScore <= 0.7) return 3;
    return 4;
};

const getStrengthConfigByLevel = (
    password: string,
    strengthLevel: number,
    strengthConfig: StrengthConfig
): { label: string; textColor: string } => {
    const defaultColor = "text-ashShade-3";

    if (password.length === 0) {
        return {
            label: "",
            textColor: defaultColor,
        };
    }

    return {
        label: strengthConfig[strengthLevel]?.label || "Unknown",
        textColor: strengthConfig[strengthLevel]?.textColor || defaultColor,
    };
};

const getSegmentColor = (
    index: number,
    strengthLevel: number,
    strengthSegments: number,
    password: string,
    strengthConfig: StrengthConfig
): string => {
    const activeSegments = Math.ceil((strengthLevel / 4) * strengthSegments);
    const defaultColor = "bg-ashShade-3";

    if (password.length === 0) return defaultColor;
    if (index < activeSegments) {
        console.log(strengthConfig[strengthLevel]?.bgColor || defaultColor);
        return strengthConfig[strengthLevel]?.bgColor || defaultColor;
    }
    return defaultColor;
};

export {
    mergeRules,
    evaluatePasswordRules,
    calculateStrengthLevel,
    getStrengthConfigByLevel,
    getSegmentColor,
};
